import common from '@/scripts/common';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import current from '@/scripts/current';
import VariableSelection from '@/bo/VariableSelection';
import VariableObject from '@/bo/VariableObject';
import VariableGroup from '@/bo/VariableGroup';
import variableDataAccess from '@/scripts/variableDataAccess';
import store from '@/store';

function getSourceCountCode(type, level) {
    if (type === 'year')
        return level.title;
    if (type === 'location')
        return store.state.selModel.locations.allIds[level.id - 1];
    else
        return null;
}
function addSourceCountCode(type, levels) {
    // console.log('levels', levels);
    const results = levels.map(l => ({
        id: l.id,
        title: l.title,
        code: getSourceCountCode(type, l)
    }));
    return results;
}
function getVariableLevelsFromApi(apiResults, variableType, variableId) {
    //The API may not use all the variables if it is missing data for year and location, so
    var matchingDefinitions = apiResults.variables.filter(v =>
        v.definition.variableType === variableType && v.definition.variableId === variableId);
    // console.log('getVariableSelectionWithApiLevels', variableSelection.type, matchingDefinitions);
    return matchingDefinitions && matchingDefinitions.length > 0 ? matchingDefinitions[0].levels : null;
}
function getVariableSelectionWithApiLevels(variableSelection, apiResults, variableType, variableId) {
    var vm = this;
    const levels = getVariableLevelsFromApi(apiResults, variableType, variableId);

    if (levels)
        variableSelection.setLevels(addSourceCountCode(variableSelection.type, levels));
    else
        console.log('Cannot find levels in API results for variable ' + variableSelection.variable.variable + '...' + variableType + variableId);
    return variableSelection;
}

export default {
    getAllSelectedVariableNames: function () {
        var selectionModel = current.selectionModel;
        return variableSelectionHelper.getAllSelectedVariables(selectionModel).map(v => v.getVariableName());
    },
    getAllSelectedVariables: function (selectionModel) {
        var variables = ['row', 'column', 'control1', 'control2', 'dependent']
            .map(n => selectionModel.v[n]).filter(v => v && v.include);
        if (selectionModel.v.independent)
            variables = [...variables, ...selectionModel.v.independent];
        return variables;
    },
    getVariableWithGroupAndCategories: function (apiResults, variableType, variableId, variableName) {
        var vm = this;
        if (variableName === null)
            return null;
        if (variableName === '_state' || variableName === 'location')
            return getVariableSelectionWithApiLevels(VariableSelection.newLocation(), apiResults, variableType, variableId);
        if (variableName === 'year')
            return getVariableSelectionWithApiLevels(VariableSelection.newYear(), apiResults, variableType, variableId);
        var variable = variableDataAccess.getByVariableName(variableName);
        var variableSelection = VariableSelection.createFromVariable(variable);
        var results = getVariableSelectionWithApiLevels(variableSelection, apiResults, variableType, variableId);
        return results;
    }
}
